import { sleep } from '~/lib';

const SERVER_RETRY_DELAY_IN_MS = 500;
// The client gets a longer delay for slow networks and parallel requests.
const CLIENT_RETRY_DELAY_IN_MS = 1000;

export const retryOnce = async <T>(fn: () => Promise<T>): Promise<T> => {
    try {
        return await fn();
    } catch {
        const isServer = typeof window === 'undefined';

        await sleep(isServer ? SERVER_RETRY_DELAY_IN_MS : CLIENT_RETRY_DELAY_IN_MS);

        return fn();
    }
};
